import { createParser, fields } from '../utils/parse';
import get from 'lodash/get';
import { LoginParser, SignUpParser } from './account';
import CoinProduct from './coinProduct';
import NavNodes, { NavNode } from './nav';
import Package from './packages';
import Pagination from './pagination';
import PackagesSeo from './packagesSeo';
import PromoBanner from './promoBanner';
import FilterGroups from './filterGroups';
import SingleCard from './singleCard';

export { default as NotificationsApi } from './notifications';

export const PackagesApi = createParser('PackagesApi', {
  packages: fields.array(Package),
  pagination: fields.object(Pagination),
  query: fields.string(''),
  seo: fields.object(PackagesSeo, { path: 'seo' }),
  sort: fields.string('Most Popular'),
  filters: fields.array(FilterGroups),
  title: fields.string('', { path: 'title' }),
  total: fields.number(0),
  color: fields.string('', { path: 'promo.bg_color' }),
  logo: fields.string('', { path: 'promo.logo_image' }),
  bannerMarkdown: fields.string('', { path: 'promo.banner_markdown' }),
  bannerTextColor: fields.string('', { path: 'promo.banner_text_color' }),
  navNode: fields.object(NavNode, { path: 'context' }),
  group: fields.object(NavNode, { path: 'context.group' }),
  section: fields.object(NavNode, { path: 'context.section' }),
  promoBanner: fields.object(PromoBanner, { path: 'promo.uplp_banner' }),
});

export const AccountApi = createParser('AccountApi', {
  account: fields.object(LoginParser),
});

export const SignUpApi = createParser('SignUpApi', {
  account: fields.object(SignUpParser),
});

export const SingleCardApi = createParser('SingleCardApi', {
  singleCard: fields.object(SingleCard),
  variations: fields.array(Package),
});

export const CoinProductsApi = createParser('CoinProductsApi', {
  coinProducts: fields.array(CoinProduct, { path: 'coin_list' }),
});

const Favorite = fields.number(-1, { transform: v => get(v, 'package_id') });

export const FavoritesApi = createParser('FavoritesApi', {
  favorites: fields.array(Favorite, { path: 'package_favorites' }),
});

export const FavoriteApi = createParser('FavoriteApi', {
  favorite: fields.object(Favorite, { path: 'package_favorite' }),
});

// export const LocaleApi = createParser('Locale', {
//   countryCode: fields.string('US', { path: 'country_code' }),
//   preferredCountryCode: fields.string('US', { path: 'preferred_country_code' }),
//   currency: fields.string('USD', { path: 'currency' }),
//   preferredCurrency: fields.string('USD', { path: 'preferred_currency' }),
// });
